import api from '@/shared/api';
import type { ApiResponse, DocumentRevisionStatus } from '@/shared/lib';
import type { FormStructure } from '@/features/FormBuilder';

export interface HomologationRecordView {
  id: number;
  prefix: string;
  title: string;
  revision: number;
  status: DocumentRevisionStatus;
  matrixStructure: FormStructure | null;
  rulesStructure: Record<string, unknown> | null;
  createdAt: string;
  effectiveDate: string | null;
  approvalManagerId: number | null;
  createdBy: { memberId: number | null; name: string | null };
}

/**
 * Le o Registro em homologacao para a tela de visualizacao.
 *
 * `GET /matrices/:id` nao serve: essa rota exige `manage:RecordManagement`, entao dá 403 no
 * aprovador e no verificador, e ainda abre rascunho. Aqui a linha precisa estar em homologacao, e o
 * acesso e decidido pela mesma regra que decidiu se o olho foi desenhado na listagem.
 */
export async function fetchHomologationRecord(
  id: number | string
): Promise<HomologationRecordView> {
  const response = await api.get<ApiResponse<HomologationRecordView>>(
    `/matrices/homologations/${id}`
  );

  if (!response.data.data) {
    throw new Error('Registro em homologação não encontrado.');
  }

  return response.data.data;
}
